import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import { WidgetFooter, WidgetHeader } from "../../widgets";
import ModalEditProfile from "../../modules/ui/Modals/ModalEditProfile";
import ModalSetting from "../../modules/ui/Modals/ModalSetting";
import {
  CLOSE_MODAL_AUTH,
  MODAL_TOGGLE,
  NEW_USER_MODAL,
} from "../../store/Modal/Modal.constant";
import ModalAuth from "../../modules/ui/Modals/ModalAuth";
import ModalConfirmation from "../../modules/ui/Modals/ModalСonfirmation";
import ModalGroupSetting from "../../modules/ui/Modals/ModalGroupSettings";
import MembersCard from "./membersCard";
import ModalManageMembersSettings from "../../modules/ui/Modals/ModalManageMembersSettings";
import { COMMON_CHANGE_SETTINGS } from "../../store/Common/Common.constant";
import { showManageMembersSettings, toggleMembersLimitSettings, deleteManageMembersSettings, updateManageMembersSettings } from "../../shared/services/Api/CommonService";
import ModalDeleteMemberSettingConfirmation from "../../modules/ui/Modals/ModalDeleteMemberSettingsConfirmation";
import AnimatedLoader from "../../modules/ui/animatedLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ModalEnableWeeklyLimitConfirmation from "../../modules/ui/Modals/ModalEnableWeeklyLimitConfirmation";

const ManageMembers = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const { slug_uuid } = useParams();
  const common = useSelector((state) => state.common);
  const modals = useSelector((store) => store.modal[slug_uuid]);
  const form = useSelector((state) => state.form);
  const groupOrders = common.groupOrders?.[slug_uuid];
  const isJoin = true;
  const settings = common.settings?.[slug_uuid];
  const [members, setMembers] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [showWeeklyLimitModal, setShowWeeklyLimitModal] = useState(false);
  const [weeklyLimitChecked, setWeeklyLimitChecked] = useState(null);

  const fetchMemberSettings = async () => {
    try {
      setIsLoading(true);
      const response = await showManageMembersSettings({
        user_id: slug_uuid,
        params: { email: debouncedSearch }
      });

      if (response) {
        setMembers(response.members);

        dispatch({
          type: COMMON_CHANGE_SETTINGS,
          payload: {
            user_id: slug_uuid,
            data: {
              member_settings: response,
            },
          },
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  // show
  useEffect(() => {
    if (token) {
      fetchMemberSettings();
    }
  }, [slug_uuid, debouncedSearch, token]);

  useEffect(() => {
    if (settings?.auth?.is_dashboard_admin === true) {
    } else {
      history.push(`/grouporder-dashboard/${slug_uuid}`)
    }
  })

  useEffect(() => {
    if (settings?.auth?.auth_token !== token) {
      dispatch({ type: NEW_USER_MODAL, payload: slug_uuid });
    }
  }, []);

  // Enable members setting manage
  const handleToggle = async (checked) => {
    try {
      setIsLoading(true);
      const response = await toggleMembersLimitSettings({ user_id: slug_uuid, enabled: checked });
      dispatch({
        type: COMMON_CHANGE_SETTINGS,
        payload: {
          user_id: slug_uuid,
          data: {
            member_settings: response
          }
        },
      });
      toast.success(response?.message);
      fetchMemberSettings();
    } finally {
      setIsLoading(false);
    }
  };

  const handleWeeklyLimitCheckbox = (e) => {
    setWeeklyLimitChecked(e.target.checked);
    setShowWeeklyLimitModal(true);
  };

  const handleWeeklyLimitConfirm = () => {
    setShowWeeklyLimitModal(false);
    handleToggle(weeklyLimitChecked);
  };

  const handleWeeklyLimitCancel = () => {
    setShowWeeklyLimitModal(false);
    setWeeklyLimitChecked(null);
  };

  const handleAddMemberClick = () => {
    dispatch({
      type: MODAL_TOGGLE,
      payload: { data: "isModalManageMembersSetting", user_id: slug_uuid },
    });
  };

  const handleMemberChange = (index, field, value) => {
    setMembers((prevMembers) =>
      prevMembers.map((member, i) =>
        i === index ? { ...member, [field]: value } : member
      )
    );
  };

  // Edit changes for a single member row
  const handleEditMember = async (index) => {
    setIsLoading(true);
    try {
      const updatedMembers = [members[index]];
      const response = await updateManageMembersSettings({
        user_id: slug_uuid,
        members: updatedMembers,
      });
      dispatch({
        type: COMMON_CHANGE_SETTINGS,
        payload: {
          user_id: slug_uuid,
          data: {
            member_settings: response,
          },
        },
      });
      toast.success(response?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRequestDeleteMember = (memberId) => {
    setMemberToDelete(memberId);
    setDeleteModalOpen(true);
  };

  // delete member from member manage settings
  const handleConfirmDeleteMember = async () => {
    if (memberToDelete) {
      try {
        setIsLoading(true);
        const response = await deleteManageMembersSettings({ user_id: slug_uuid, id: memberToDelete });

        setMembers((prev) => prev.filter((member) => member.id !== memberToDelete));

        const currentMemberSettings = settings?.member_settings || {};
        const updatedMembers = (currentMemberSettings.members || []).filter(
          (member) => member.id !== memberToDelete
        );

        dispatch({
          type: COMMON_CHANGE_SETTINGS,
          payload: {
            user_id: slug_uuid,
            data: {
              member_settings: {
                ...currentMemberSettings,
                members: updatedMembers,
              },
            },
          },
        });
        toast.success(response?.message);
      } finally {
        setIsLoading(false);
        setDeleteModalOpen(false);
        setMemberToDelete(null);
      }
    }
  };

  return (
    <>
      <AnimatedLoader isLoading={isLoading} />
      <WidgetHeader
        user_id={slug_uuid}
        isJoin={isJoin}
        auth={settings?.auth}
        creator_id={slug_uuid}
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Manage Members</title>
        <meta id="meta-description" name="description" content={"njjn"} />
      </Helmet>
      {modals?.isModalAuth ? (
        <ModalAuth
          user_id={slug_uuid}
          error={form.form?.error?.message}
          show={modals.isModalAuth}
          onHide={() =>
            dispatch({ type: CLOSE_MODAL_AUTH, payload: slug_uuid })
          }
        />
      ) : null}
      <ToastContainer progressClassName="fancy-progress-bar" />
      {modals?.isModalConfirmation ? (
        <ModalConfirmation
          user_id={slug_uuid}
          isResendCode={settings?.isResendCode}
          error={form.form?.error?.message}
          show={modals.isModalConfirmation}
          order_deadline={groupOrders?.order_deadline * 1000}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalConfirmation", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalEditProfile ? (
        <ModalEditProfile
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalEditProfile}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalEditProfile", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalSetting ? (
        <ModalSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalGroupSetting ? (
        <ModalGroupSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalGroupSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalGroupSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalManageMembersSetting ? (
        <ModalManageMembersSettings
          show={modals.isModalManageMembersSetting}
          user_id={slug_uuid}
          onHide={async () => {
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalManageMembersSetting", user_id: slug_uuid },
            })
            setIsLoading(true);
            try {
              const response = await showManageMembersSettings({ user_id: slug_uuid });
              if (response) setMembers(response.members);
            } finally {
              setIsLoading(false);
            }
          }}
        />
      ) : null}
      <div className="manage-members-container">
        <h2 className="manage-members-title">Manage Members</h2>
        <div className="manage-members-card">
          <div className="manage-members-actions">
            <div className="members-setting-toggle">
              <label>
                <input
                  type="checkbox"
                  checked={settings?.member_settings?.enable_members_limit_setting}
                  onChange={handleWeeklyLimitCheckbox}
                />
                <span>Enable weekly limitations</span>
              </label>
            </div>
            <div className="manage-members-search">
              <input
                type="text"
                placeholder="Search by email"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div className="manage-members-buttons">
              <button className="add-members-action-button" onClick={handleAddMemberClick}>
                Add Members
              </button>
            </div>
          </div>
          <MembersCard
            data={members}
            onChangeMember={handleMemberChange}
            onDeleteMember={handleRequestDeleteMember}
            onEditMember={handleEditMember}
          />
          <ModalDeleteMemberSettingConfirmation
            show={deleteModalOpen}
            onConfirm={handleConfirmDeleteMember}
            onClose={() => {
              setDeleteModalOpen(false);
              setMemberToDelete(null);
            }}
          />
        </div>
      </div>
      <ModalEnableWeeklyLimitConfirmation
        show={showWeeklyLimitModal}
        onConfirm={handleWeeklyLimitConfirm}
        onClose={handleWeeklyLimitCancel}
        isEnabling={weeklyLimitChecked}
      />
      <WidgetFooter />
    </>
  );
};

export default ManageMembers;
